import React from 'react'

function Portfolio() {
  console.log('hello')
  return (
    <h1>404 Not Found.</h1>
  )
}

export default Portfolio;